<template>
  <div class="add-basic-information">
    <div class="add-title">
      <span class="basic title-font-style">收货信息</span>
      <div class="save">
        <el-button v-if="isEdit" type="primary" @click="onReceiving" plain>添加收货人</el-button>
        <el-button
          type="primary"
          v-if="(this.$route.path === '/crm/customer/details'||this.$route.path === '/crm/supplier/supplierEdit')&&isEdit"
          @click="onSave"
        >保存</el-button>
        <el-button
          type="primary"
          v-if="(this.$route.path === '/crm/customer/details'||this.$route.path === '/crm/supplier/supplierEdit')&&!isEdit"
          @click="onDetail"
        >编辑</el-button>
      </div>
    </div>
    <div  v-for="(item,index) in queryParams" :key="index"  class="add-content" style='padding-left:50px;padding-bottom:10px'>
      <el-form class="demo-form-inline"  :label-width='!isEdit ? "" : "95px"' ref="queryParams">
        <el-row :gutter="20">
          <el-col :span="8" style="padding:0px;">
            <el-col :span="20">
              <el-form-item label="收货人：" prop="productClass">
                <span v-if="!isEdit">{{item.crName || '--'}}</span>
                <el-input v-else v-model="item.crName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4" v-if="item.isDefault === true">
              <el-form-item label-width="0px">
                <el-button size="mini" class="main-contact" style='position: absolute;right:12px' >主收货人</el-button>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">
              <span v-if="!isEdit">{{item.crPhone || '--'}}</span>
              <el-input @input.native="onInput"  v-else v-model="item.crPhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收货地址：">
              <span v-show="!isEdit">{{item.crProvince || '--'}}</span>
              <el-address
                v-model='item.crProvince'
                v-show="isEdit"
                :provinceEdit="item.provinceReceiving"
                :city="item.cityReceiving"
                :district="item.districtReceiving"
                @changAddress="changAddress($event,index)"
              ></el-address>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="详细地址：" >
              <span v-if="!isEdit">{{item.crAddress || '--'}}</span>
              <el-input v-else v-model="item.crAddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="!item.isDefault">
          <el-col :span="24" style="text-align:right;margin-top:10px;margin-bottom:10px;">
            <el-button  @click="onDelete(item,index)">删除</el-button>
            <el-button
              @click="onMainLinkman(item,index)"
              plain
              type="primary"
            >设为主收货人</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import address from '@/components/Address/index'
import {
  updateCustomerRecevieInfo,
  customerRecevieInfoDelete,
  customerRecevieInfoUpdateByIsDefault
} from '@/api/customer/customerManage'
import {
  supplierRecgoodsUpdateById,
  supplierRecgoodsDelete,
  supplierRecevieGoodsByIsDefault
} from '@/api/supplier/supplierManage'
export default {
  components: {
    'el-address': address
  },
  props: ['isShow', 'receivingInformation'],
  data () {
    return {
      queryParams: [],
      isEdit: true
    }
  },
  watch: {
    receivingInformation (val, oldVal) {
      if (this.$route.path === '/crm/supplier/supplierEdit') {
        // 供应商收货信息编辑参数转换
        const shippingAddress = []
        this.receivingInformation.forEach((item) => {
          let recParams = {}
          if (item.recProcode || item.recProvince) {
            recParams = this.$analysisAddress(item.recProcode, item.recProvince) // 传给子组件的id和name
          }
          const params = {
            // 收货地址
            flag: item.flag,
            crAddress: item.recAddress,
            crName: item.recContacts,
            crInfo: item.recInfo,
            isDefault: item.isDefault,
            crPhone: item.recPhone,
            crProcode: item.recProcode,
            crProvince: item.recProvince,
            cbId: item.suId,
            id: item.id,
            provinceReceiving: recParams.province, // 省
            cityReceiving: recParams.city, // 市
            districtReceiving: recParams.district // 县
          }
          if (params.isDefault) {
            shippingAddress.unshift(params)
          } else {
            shippingAddress.push(params)
          }
        })
        this.queryParams = shippingAddress
      } else if (this.$route.path === '/crm/customer/details') {
        // 客户管理收货信息
        this.queryParams = this.receivingInformation
      }
    }
  },
  mounted () {
    this.isEdit = this.isShow
    if (
      this.$route.path === '/crm/customer/addCustomers' ||
      this.$route.path === '/crm/supplier/supplierAdd'
    ) {
      this.queryParams = [
        {
          isDefault: true,
          crProvince: '',
          crProcode: '',
          flag: true,
          provinceReceiving: {}, // 收货省
          cityReceiving: {}, // 收货市
          districtReceiving: {} // 收货区/县
        }
      ]
    }
  },
  methods: {
    onInput(e) {
      // 过滤非数字和符号
      const regName = /^[\d-]+$/
      if (!regName.test(e.target.value)) {
        e.target.value = ''
      } else {
        return true
      }
    },
    // 添加收货信息
    onReceiving () {
      if (
        this.$route.path === '/crm/customer/details' ||
        this.$route.path === '/crm/supplier/supplierEdit'
      ) {
        const params = {
          isDefault: false,
          cbId: this.$route.query.id,
          flag: true
        }
        this.queryParams.push(params)
      } else {
        const params = { isDefault: false, flag: true }
        this.queryParams.push(params)
      }
    },
    // 删除收货信息
    onDelete (val, index) {
      if (this.queryParams.length > 1) {
        // 客户管理,供应商管理添加中的删除
        if (
          this.$route.path === '/crm/customer/addCustomers' ||
          this.$route.path === '/crm/supplier/supplierAdd'
        ) {
          if (val.isDefault === true) {
            this.queryParams.splice(index, 1)
            this.queryParams[0].isDefault = true
          } else {
            this.queryParams.splice(index, 1)
          }
        } else {
          // 客户管理,供应商管理详情收货信息
          if (val.id) {
            if (this.$route.path === '/crm/customer/details') {
              // 客户详情删除收货人
              this.getCustomerRecevieInfoDelete(val.id, index)
            } else if (this.$route.path === '/crm/supplier/supplierEdit') {
              // 供应商详情删除收货人
              this.getSupplierRecgoodsDelete(val.id, index)
            }
          } else {
            // 没有保存的数据删除
            this.queryParams.splice(index, 1)
          }
        }
      } else {
        this.$message.error('收货信息必须保留一个!')
      }
    },
    // 客户详情根据联系人id删除收货人
    getCustomerRecevieInfoDelete (id, index) {
      customerRecevieInfoDelete(id)
        .then((res) => {
          if (res.data.code === 200) {
            this.queryParams.splice(index, 1)
            this.queryParams.forEach((item) => {
              // 根据返回的id设置主收货人
              if (item.id === res.data.obj) {
                item.isDefault = true
              }
            })
            this.$message.success('删除成功')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 供应商详情根据联系人id删除收货人
    getSupplierRecgoodsDelete (id, index) {
      supplierRecgoodsDelete(id)
        .then((res) => {
          if (res.data.code === 200) {
            this.queryParams.splice(index, 1)
            this.queryParams.forEach((item) => {
              // 根据返回的id设置主收货人
              if (item.id === res.data.obj) {
                item.isDefault = true
              }
            })
            this.$message.success('删除成功')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 通过省id获取市级
    changAddress (params, index) {
      this.queryParams[index].crProvince = params.name
      this.queryParams[index].crProcode = params.code
    },
    // 设为主收货人
    onMainLinkman (row, index) {
      if (row.id) {
        if (this.$route.path === '/crm/customer/details') {
          // 客户详情设为主收货人
          customerRecevieInfoUpdateByIsDefault(row.id, row.cbId)
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success('已成功设为主联系人')
                for (let i = 0; i < this.queryParams.length; i++) {
                  if (i === index) {
                    this.queryParams[i].isDefault = true
                  } else {
                    this.queryParams[i].isDefault = false
                  }
                }
                this.queryParams.unshift(this.queryParams[index])
                this.queryParams.splice(index + 1, 1)
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else if (this.$route.path === '/crm/supplier/supplierEdit') {
          // 供应商详情设为主收货人
          supplierRecevieGoodsByIsDefault(row.id, row.cbId)
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success('已成功设为主联系人')
                for (let i = 0; i < this.queryParams.length; i++) {
                  if (i === index) {
                    this.queryParams[i].isDefault = true
                  } else {
                    this.queryParams[i].isDefault = false
                  }
                }
                this.queryParams.unshift(this.queryParams[index])
                this.queryParams.splice(index + 1, 1)
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        }
      } else {
        this.queryParams.forEach(ele => { ele.isDefault = false })
        const obj = JSON.parse(JSON.stringify(row))
        obj.isDefault = true
        this.queryParams.splice(index, 1)
        this.queryParams.unshift(obj)
        this.getListAddress()
      }
    },
    // 编辑
    onDetail () {
      this.isEdit = true
      this.getListAddress()
    },
    // 点击编辑时,由于后端没有给前端需要的数据格式,所以需要前端封装方法并且给子组件地址赋值
    getListAddress () {
      this.queryParams.forEach((item) => {
        if (item.crProcode || item.crProvince) {
          const recParams = this.$analysisAddress(
            item.crProcode,
            item.crProvince
          )
          item.provinceReceiving = recParams.province
          item.cityReceiving = recParams.city
          item.districtReceiving = recParams.district
        }
      })
    },
    // 保存
    onSave () {
      if (this.$route.path === '/crm/supplier/supplierEdit') {
        // 供应商保存收货地址信息
        let isBool = false
        let isBeen = false
        this.queryParams.forEach(ele => {
          if (ele.crAddress || ele.crProvince || ele.crName || ele.crPhone) {
            if (!ele.crAddress || !ele.crProvince || !ele.crName || !ele.crPhone) {
              isBool = true
            }
          } else {
            if (!ele.crAddress && !ele.crProvince && !ele.crName && !ele.crPhone) {
              isBeen = false
            }
          }
        })
        if (isBool) {
          this.$message.error('收货信息请完整填写')
          return
        }
        if (isBeen) {
          this.$message.error('收货信息不能为空')
          return
        }
        const shippingAddress = []
        this.queryParams.forEach((item) => {
          const params = {
            // 收货地址
            flag: item.flag,
            recAddress: item.crAddress,
            recContacts: item.crName,
            recInfo: item.crInfo,
            isDefault: item.isDefault,
            recPhone: item.crPhone,
            recProcode: item.crProcode,
            recProvince: item.crProvince,
            id: item.id,
            suId: item.cbId
          }
          shippingAddress.push(params)
        })
        supplierRecgoodsUpdateById(this.$route.query.id, shippingAddress)
          .then((res) => {
            if (res.data.code === 200) {
              const shippingAddress = []
              res.data.obj.forEach((item) => {
                let recParams = {}
                if (item.recProcode || item.recProvince) {
                  recParams = this.$analysisAddress(
                    item.recProcode,
                    item.recProvince
                  ) // 传给子组件的id和name
                }
                const params = {
                  // 收货地址
                  flag: item.flag,
                  crAddress: item.recAddress,
                  crName: item.recContacts,
                  crInfo: item.recInfo,
                  isDefault: item.isDefault,
                  crPhone: item.recPhone,
                  crProcode: item.recProcode,
                  crProvince: item.recProvince,
                  cbId: item.suId,
                  id: item.id,
                  provinceReceiving: recParams.province, // 省
                  cityReceiving: recParams.city, // 市
                  districtReceiving: recParams.district // 县
                }
                if (params.isDefault) {
                  shippingAddress.unshift(params)
                } else {
                  shippingAddress.push(params)
                }
              })
              this.queryParams = shippingAddress
              this.$message.success('保存成功!')
              this.isEdit = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else if (this.$route.path === '/crm/customer/details') {
        let isBool = false
        let isBeen = false
        this.queryParams.forEach(ele => {
          if (ele.crAddress || ele.crProvince || ele.crName || ele.crPhone) {
            if (!ele.crAddress || !ele.crProvince || !ele.crName || !ele.crPhone) {
              isBool = true
            }
          } else {
            if (!ele.crAddress && !ele.crProvince && !ele.crName && !ele.crPhone) {
              isBeen = false
            }
          }
        })
        if (isBool) {
          this.$message.error('收货信息请完整填写')
          return
        }
        if (isBeen) {
          this.$message.error('收货信息不能为空')
          return
        }
        const arrList = []
        this.queryParams.forEach((item) => {
          const params = {
            flag: item.flag,
            cbId: item.cbId,
            crAddress: item.crAddress,
            crInfo: item.crInfo,
            crName: item.crName,
            crPhone: item.crPhone,
            crProcode: item.crProcode,
            crProvince: item.crProvince,
            id: item.id,
            isDefault: item.isDefault
          }
          arrList.push(params)
        })
        updateCustomerRecevieInfo(arrList)
          .then((res) => {
            if (res.data.code === 200) {
              const shippingAddress = []
              res.data.obj.forEach((item) => {
                let recParams = {}
                if (item.recProcode || item.recProvince) {
                  recParams = this.$analysisAddress(
                    item.recProcode,
                    item.recProvince
                  ) // 传给子组件的id和name
                }
                const params = {
                  // 收货地址
                  flag: item.flag,
                  crAddress: item.crAddress,
                  crName: item.crName,
                  crInfo: item.crInfo,
                  isDefault: item.isDefault,
                  crPhone: item.crPhone,
                  crProcode: item.crProcode,
                  crProvince: item.crProvince,
                  cbId: item.cbId,
                  id: item.id,
                  provinceReceiving: recParams.province, // 省
                  cityReceiving: recParams.city, // 市
                  districtReceiving: recParams.district // 县
                }
                if (params.isDefault) {
                  shippingAddress.unshift(params)
                } else {
                  shippingAddress.push(params)
                }
              })
              this.queryParams = shippingAddress
              this.$message.success('保存成功!')
              this.isEdit = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    onReceivingRuls () {
      this.queryParams.forEach(ele => {
        let been = false
        this.queryParams.forEach(ele => {
          if (ele.crAddress || ele.crProvince || ele.crName || ele.crPhone) {
            if (!ele.crAddress || !ele.crProvince || !ele.crName || !ele.crPhone) {
              been = true
            }
          }
        })
        if (been) {
          this.$emit('onParent', false)
        } else {
          this.$emit('onParent', true)
        }
      })
    }
  }
}
</script>
